module.exports = "/images/icon_arrow_03_02.png?d93d52bb962292401f43a520268c3ea9";